<template>
  <div style="width: 100%">
    <div class="full-screen driver__container">
      <side-menu/>
      <router-view/>
    </div>
    <footer-view style="border-top: 1px solid;"></footer-view>
  </div>
</template>

<script>
import SideMenu from '@components/menu/SideMenu.vue'
import FooterView from '@components/footer/FooterView.vue'
export default {
  name: 'Driver',
  components: {
    SideMenu,
    FooterView
  }
}
</script>
